import { useContext, useEffect } from "react"
import { Field } from "formik"

import { FormContext } from "../../context/formContext"
import { Calendar } from "primereact/calendar"

import styles from "../../styles/Form.module.css"

import fieldVisibility from "../../helpers/fieldVisibility"

import { useFormikContext } from "formik"
import { DateTime } from "luxon"

export default function TypeTime({ field, block, index }) {
  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const formik = useFormikContext()

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const startDate = DateTime.fromJSDate(formik.values.session_start_time)
    const endDate = DateTime.fromJSDate(formik.values.session_end_time)

    // Check if dates are on different days
    if (
      startDate.startOf("day") > endDate.startOf("day") ||
      startDate.startOf("day") < endDate.startOf("day")
    ) {
      let fixedDate = startDate
      let newDate = fixedDate.set({
        hour: endDate.hour,
        minute: endDate.minute,
      })

      const utcDate = newDate.toUTC().toJSDate()
      if (formik.values.session_end_time !== utcDate) {
        formik.setFieldValue("session_end_time", utcDate)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.session_end_time])

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => (
            <>
              <Calendar
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                onBlur={formikField.onBlur}
                timeOnly
                hourFormat="12"
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
